import React from "react";
import { useIntl } from "react-intl";
import { formatDate } from "../../Utilities/dateUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ExpiringLicense = props => {
  const intl = useIntl();
  if (props.licenses === null) {
    return <div />;
  }

  let expiringLicenses = [];

  props.licenses.forEach(license => {
    if (license.hasExpireWarning || license.hasExpired)
      expiringLicenses.push({
        name: license.name,
        expireDate: license.validTo,
        hasExpireWarning: license.hasExpireWarning,
        hasExpired: license.hasExpired
      });
  });

  if (expiringLicenses.length === 0) {
    return <div />;
  }

  let hasExpiredLicenses =
    expiringLicenses.filter(x => x.hasExpired).length > 0;
  let message = hasExpiredLicenses
    ? intl.formatMessage({ id: "ExpiredLicenseLabel" })
    : intl.formatMessage({ id: "ExpiringLicenseLabel" });

  return (
    <FontAwesomeIcon
      icon="triangle-exclamation"
      className={hasExpiredLicenses ? "text-danger" : "text-warning"}
      title={
        message +
        expiringLicenses
          .map(x => x.name + ": " + formatDate(x.expireDate, "yyyy-MM-dd"))
          .join(" | ")
      }
    />
  );
};

export default ExpiringLicense;
